import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";

export function ProtectedRoute({
  children,
  role,
  requireOnboarded = true,
}: {
  children: ReactNode;
  role?: "talent" | "company";
  requireOnboarded?: boolean;
}) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="h-6 w-6 animate-spin rounded-full border-2 border-slate-200 border-t-teal" />
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  if (requireOnboarded && !user.onboarded) return <Navigate to="/onboarding" replace />;
  if (role && user.role !== role) {
    return <Navigate to={user.role === "company" ? "/company" : "/app"} replace />;
  }

  return <>{children}</>;
}
